// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2HpIG","paramInput":"JobSimulator_paramInput__atA5c","input":"JobSimulator_input__33JN6"};